import { z } from "zod";

export const reminderAckSchema = z.object({
  keys: z.array(z.string().trim().min(1).max(200)).min(1).max(200),
});
